<template>
  <div class="boxFile" :class="{ 'uploading': loadingUpload }">
    <TextInput :hide-input="iValue" type="file" :label="label" accept="image/*" @changed="(file) => choosedFile(file)" />
    <div class="text-left mb-3" :style="{ marginTop: (iValue ? '-1rem' : 0) }">
      <img v-if="tempImage" :src="tempImage" alt="" :style="{ height: '180px' }" :class="{ 'full-width': fullWidth }" />
      <div v-if="iValue" class="mt-2">
        <b-button variant="outline-primary mr-1" size="sm" :disabled="loadingGenerate" @click="generateMetaImage">
          <b-spinner small v-if="loadingGenerate" class="mr-1" />
          Regenerate With AI
        </b-button>
        <b-button variant="outline-danger" size="sm" @click="deleteFile">Delete</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import './Styles/UploadImage.scss'
export default {
  props: {
    value: { type: String, default: null },
    label: { type: String, default: null },
    fullWidth: { type: Boolean, default: false },
    blog: { type: Object, default: null },
  },
  data() {
    return {
      loadingUpload: false,
      loadingGenerate: false,
      tempImage: null
    }
  },
  computed: {
    user() { return this.$store.getters['auth/user'] },
    iValue: {
      get() { return this.value },
      set(newValue) { this.$emit('input', newValue) }
    }
  },
  mounted() { this.tempImage = this.value },
  watch: {
    value(newVal) {
      this.tempImage = newVal; // Update preview when value changes
    }
  },
  methods: {
    choosedFile(file) {
      const img = new Image();
      img.onload = () => {
        const ratio = img.width / img.height;
        if (Math.abs(ratio - 16 / 9) > 0.01) {
          this.$toast.error("Only 16:9 images are allowed.", { position: 'bottom' });
          this.loadingUpload = false;
          return;
        }

        // Proceed with upload
        this.loadingUpload = true
        let uploadForm = new FormData();
        uploadForm.append('file', file);
        this.$store.dispatch('image/uploadNonConvertImage', uploadForm)
          .then((response) => {
            this.iValue = response.url;
            this.tempImage = response.url;
            this.loadingUpload = false;
          })
          .catch((err) => {
            this.loadingUpload = false;
            alert(err?.response?.data?.error || "Upload failed.");
          });
      };
      img.src = URL.createObjectURL(file);

      let reader = new FileReader()
      reader.onload = () => {}
      reader.readAsDataURL(file)
    },
    deleteFile() {
      this.iValue = null
      this.tempImage = null
    },
    generateMetaImage() {
      this.loadingGenerate = true
      const paramBlog = { ...this.blog, 'agency_id': this.user.agency.id }

      this.$store
        .dispatch('image/generateAIImage', paramBlog)
        .then((response) => {
          this.iValue = response.url
          this.tempImage = response.url
          this.loadingUpload = false
          this.loadingGenerate = false
        })
        .catch(() => this.loadingUpload = false)
    },
  }
}
</script>